import * as z from 'zod';

import { countries } from './countries';

const countriesZod = z.object({
  name: z.string(),
  value: z.enum(['', ...countries.map((item) => item.name)]),
});

type TCountry = z.infer<typeof countriesZod>;

const defaultStatus: TCountry = { name: 'None', value: '' };

export const countryOptions: TCountry[] = [
  defaultStatus,
  ...countries.map((item) => ({ name: item.name, value: item.name })),
];

export function countriesOptionsSchema() {
  return countriesZod.refine(({ value }) => value !== '', {
    message: "Country field can't be Empty",
  });
}

export function strToCountry(str: string): TCountry {
  return countryOptions.find((item) => item.value === str) ?? defaultStatus;
}

export function countryCallingCodeToCountry(str: string) {
  return countries.find((item) => item.calling_code === str);
}
